export default "__VITE_ASSET__23b03e09__"